import * as api from "./middleware/api.middleware";

const serviceUrl = "login";

export function getLoginAccessToken(
  username: string,
  password: string,
  forceNewToken = false
) {
  const bodyFormData = new FormData();
  bodyFormData.append("username", username);
  bodyFormData.append("password", password);
  const query = forceNewToken ? "?force_new_token=true" : "";
  return api.postFormData<any>(
    `${serviceUrl}/access_token${query}`,
    bodyFormData
  );
}
